// Legacy Orchestrator Live View URL — the cinematic stage moved into the
// unified Inbox as its Coordinator view (`/inbox/coordinator`) in the
// 2026-07 nav review. Settings + Analytics stay under /orchestrator.
import { createFileRoute, redirect } from '@tanstack/react-router';

import { routes } from '../../lib/constants';

export const Route = createFileRoute('/orchestrator/live')({
  beforeLoad: () => {
    throw redirect({ to: routes.INBOX_COORDINATOR, replace: true });
  },
  component: () => null,
});
